import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import TabletAndroidIcon from '@mui/icons-material/TabletAndroid';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import type { OrigemPedidoAdmin, TipoIdentificador } from '../../api';

/**
 * Ícone e rótulo de cada modo — os MESMOS das abas de configuração, em um lugar
 * só.
 *
 * O mapa já existia copiado no card de pontos de acesso e o rótulo, de novo, no
 * diálogo do QR; a tela de acessos não tinha nenhum dos dois e mostrava o enum
 * cru ("TOTEM_CHECKOUT") na coluna de tipo. Ícone e nome de um modo são a
 * mesma decisão de produto, então moram juntos e valem para o backoffice
 * inteiro.
 */
export const ROTULO_TIPO_IDENTIFICADOR: Record<TipoIdentificador, string> = {
  MESA: 'Mesa',
  COMANDA: 'Comanda',
  TOTEM: 'Totem',
  TOTEM_CHECKOUT: 'Totem Checkout',
  TABLET: 'Tablet (na mesa)',
  DELIVERY: 'Delivery',
  VITRINE: 'Vitrine',
};

export function IconeTipoIdentificador({
  tipo,
  fontSize = 'small',
}: {
  tipo: TipoIdentificador;
  fontSize?: 'small' | 'medium' | 'large';
}): JSX.Element {
  switch (tipo) {
    case 'MESA':
      return <TableRestaurantIcon fontSize={fontSize} />;
    case 'COMANDA':
      return <ReceiptLongIcon fontSize={fontSize} />;
    case 'VITRINE':
      return <StorefrontIcon fontSize={fontSize} />;
    case 'TOTEM':
      return <SlideshowIcon fontSize={fontSize} />;
    case 'TOTEM_CHECKOUT':
      return <PointOfSaleIcon fontSize={fontSize} />;
    case 'TABLET':
      // Deitado, como o aparelho fica preso na mesa — igual à aba dele.
      return <TabletAndroidIcon fontSize={fontSize} sx={{ transform: 'rotate(90deg)' }} />;
    case 'DELIVERY':
    default:
      return <DeliveryDiningIcon fontSize={fontSize} />;
  }
}

/**
 * A ORIGEM do pedido é mais grossa que o tipo do ponto de acesso: mesa, comanda
 * e tablet chegam como MESA_COMANDA, porque para o pedido o que importa é ter
 * caído na conta do salão, não por qual aparelho entrou.
 */
export const ROTULO_ORIGEM_PEDIDO: Record<OrigemPedidoAdmin, string> = {
  MESA_COMANDA: 'Mesa/Comanda',
  DELIVERY: 'Delivery',
  TOTEM: 'Totem',
};

export function IconeOrigemPedido({ origem }: { origem: OrigemPedidoAdmin }): JSX.Element {
  switch (origem) {
    case 'MESA_COMANDA':
      return <TableRestaurantIcon fontSize="small" />;
    case 'TOTEM':
      return <SlideshowIcon fontSize="small" />;
    case 'DELIVERY':
    default:
      return <DeliveryDiningIcon fontSize="small" />;
  }
}
